export { MdPeople as IconIntervention } from "react-icons/md";
